module.exports = __webpack_public_path__ + "78871e5d79702e192e3412cd0a628dc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-15.png
// module id = 3122
// module chunks = 0